import { trackViaHTTPApi } from './http-api';

/**
 * Tracks a page view event.
 * @param pageTitle - Title of the page being viewed (optional).
 * @returns Promise resolving to `true` if successful.
 */
export function trackPageView(pageTitle: string = ''): Promise<boolean> {
  console.log('[Matomo helper] track page view', pageTitle);
  const params = [];
  if (pageTitle !== '') {
    params.push(`action_name=${encodeURIComponent(pageTitle)}`);
  }
  return trackViaHTTPApi(params);
}
